/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

import { setProductsAreInStock } from './other/actions';

/**
 * Dialog qui s'ouvre systèmatiquement lors de l'import de commande
 * permettant de savoir si les produits sont chez SYMPL
 * @param {Boolean} isOpen                        Statut de la boite de dialog ouvert ou fermer
 * @param {Function} handleCloseDialogIsInStock   Fermeture de la boite de Dialog
 * @param {Function} dispatchSetProductIsInStock  Met à jour la donnée pour indiqué si le produit est en stock ou pas
 * @param {Function} processing                   Function permettant d'exécuter le traitement du fichier
 */
const IsInStockDialog = ({
  isOpen,
  handleCloseDialogIsInStock,
  dispatchSetProductsAreInStock,
  processing
}) => (
  <div>
    <Dialog open={isOpen} onClose={() => handleCloseDialogIsInStock()}>
      <DialogContent style={{ padding: 20 }}>
        <Button
          color="primary"
          variant="contained"
          style={{ width: '100%' }}
          onClick={() => {
            dispatchSetProductsAreInStock(false);
            handleCloseDialogIsInStock();
            processing();
          }}
        >
          Un coursier doit venir chercher mon stock ou je l'emmène chez Sympl
        </Button>
        <Button
          color="primary"
          variant="contained"
          style={{ width: '100%', marginTop: 30 }}
          onClick={() => {
            dispatchSetProductsAreInStock(true);
            handleCloseDialogIsInStock();
            processing();
          }}
        >
          Les produits sont déja chez Sympl
        </Button>
      </DialogContent>
    </Dialog>
  </div>
);

const mapDispatchToProps = dispatch => ({
  dispatchSetProductsAreInStock: isInStock =>
    dispatch(setProductsAreInStock(isInStock))
});

IsInStockDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleCloseDialogIsInStock: PropTypes.func.isRequired,
  dispatchSetProductsAreInStock: PropTypes.func.isRequired,
  processing: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(IsInStockDialog);
